import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../CustomComponent/custom_view_button";

import { extractDate } from "../../Components/Functions/date.fun";
import SimpleButton from "../../Components/layouts/simple_button";
import { FaStar } from "react-icons/fa";

const tableHead = [
  "ID",
  "Date",
  "Full Name",
  "Origin",
  "Mobile Number",
  "Mark As Read",
  "Actions",
];

const EnquiryTable = ({ data = [] }) => {
  const navigate = useNavigate();
  const goToCreate = (data) => {
    navigate(`/create-enquiry?id=${data?.id}`);
  };
  const [leads, setLeads] = useState(data);

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {leads?.map((item, index) => {
            return (
              <tr
                key={item?.id}
              >
                <td>{item?.id || "N/A"}</td>
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td>{item?.fullName || "N/A"}</td>
                <td>{item?.origin || "N/A"}</td>
                <td>
                  {item?.mobileNumber ||
                    item?.alternativeNumber ||
                    item?.whatsappNumber ||
                    "N/A"}
                </td>
                <td>
                  <FaStar
                    fontSize="24px"
                    color={item?.enquiryRelated ? "orange" : "grey"}
                  />
                </td>
                <td>
                  <button
                    className="btn btn-primary"
                    onClick={() => goToCreate(item)}
                  >
                    CREATE ENQUIRY
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default EnquiryTable;
